var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',[_c('b-form-checkbox',{attrs:{"data-test":"for-compensation","name":"for-compensation"},model:{value:(_vm.isForCompensation),callback:function ($$v) {_vm.isForCompensation=$$v},expression:"isForCompensation"}},[_vm._v(_vm._s(_vm.$t('For Compensation')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }